module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/json/stringify.js
// module id = ./node_modules/@babel/runtime/core-js/json/stringify.js
// module chunks = 1 5 6 7 8 9 10 11 12